import { useState } from 'react';
import { useApp } from '../lib/AppContext';
import { AvatarPair, FoodsSheet, LeaveSheet, ManageSheet, SlotPicker } from './PairSheets';

// The avatar pair in a menu header and everything it opens: ⑦ manage, ④ shared meals, foods to avoid, ⑧ leave.
// `onChanged` runs after anything that may have changed the menu (reload it).
export default function PairManager({ state, setState, onChanged, slotsOpen, setSlotsOpen }) {
  const { api, openPaywall } = useApp();
  const [sheet, setSheet] = useState(null); // null | 'manage' | 'foods' | 'leave'
  const [note, setNote] = useState(null);
  const pair = state?.pair;
  if (!pair) return null;
  const openSlots = () => {
    setSheet(null);
    if (!pair.can_edit) openPaywall('pro_required');
    else setSlotsOpen(true);
  };
  return (
    <>
      <AvatarPair pair={pair} onClick={() => setSheet('manage')} />
      <ManageSheet open={sheet === 'manage'} pair={pair} onClose={() => setSheet(null)}
        onSlots={openSlots} onFoods={() => setSheet('foods')} onLeave={() => setSheet('leave')} />
      <SlotPicker open={slotsOpen} pair={pair} onClose={() => setSlotsOpen(false)}
        onSave={async (slots) => { setState(await api.patch('/cooking_pair', { shared_slots: slots })); setSlotsOpen(false); onChanged?.(); }} />
      <FoodsSheet open={sheet === 'foods'} onClose={() => setSheet(null)}
        onSaved={async (swapped) => {
          setSheet(null);
          setState(await api.get('/cooking_pair'));
          if (swapped) setNote(`Đã đổi ${swapped} bữa ăn chung có món bạn không ăn được.`);
          onChanged?.();
        }} />
      <LeaveSheet open={sheet === 'leave'} pair={pair} onClose={() => setSheet(null)}
        onLeave={async (choice) => { setState(await api.del('/cooking_pair', { choice })); setSheet(null); onChanged?.(); }} />
      {note && (
        <p role="status" className="fixed inset-x-4 bottom-24 z-40 rounded-[14px] bg-[#17201b] px-4 py-3 text-sm text-white" onClick={() => setNote(null)}>{note}</p>
      )}
    </>
  );
}
